import { AlpineComponent } from '@alpinejs/csp';

const Animation = (): AlpineComponent => ({
  animation: undefined,

  animationUrl: undefined,
  mobileAnimationUrl: undefined,

  init() {
    this.loop = this.$root.dataset.loop === 'true';
    this.autoplay = this.$root.dataset.autoplay === 'true';

    this.animationUrl = this.$root.dataset.animation;
    this.mobileAnimationUrl = this.$root.dataset.mobileAnimation;

    (async () => {
      const { default: Lottie } = await import('lottie-web');

      this.animation = Lottie.loadAnimation({
        container: this.$root,
        renderer: 'svg',
        loop: this.loop,
        autoplay: this.autoplay,
        path:
          window.innerWidth < 768
            ? this.mobileAnimationUrl || this.animationUrl
            : this.animationUrl
      });
    })();
  }
});

export default Animation;
